// src/components/AuthorInfo.js
import React from 'react';
import { Link } from 'react-router-dom';

const AuthorInfo = ({ author }) => {
  if (!author) {
    return null;
  }

  const authorName = author.firstName && author.lastName 
    ? `${author.firstName} ${author.lastName}`
    : author.username || 'Anonymous';

  const authorImage = author.profileImage || author.avatar || 'https://via.placeholder.com/50';
  const authorBio = author.bio || author.description || 'No bio available';

  return (
    <div className="mt-12 p-4 bg-gray-100 rounded-lg">
      <h2 className="text-xl font-bold">About the Author</h2>
      <div className="flex items-center mt-4">
        <img 
          src={authorImage} 
          alt={authorName} 
          className="w-16 h-16 rounded-full object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://via.placeholder.com/50';
          }}
        />
        <div className="ml-4">
          <h3 className="font-bold">{authorName}</h3>
          <p className="text-gray-600 text-sm">{authorBio}</p>
          {author.username && (
            <Link 
              to={`/author/${author.username}`}
              className="text-blue-500 hover:text-blue-700 text-sm mt-1 inline-block"
            >
              View all posts
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthorInfo;
